import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalLayout from '../components/layout/LegalLayout';
import './PrivacyPage.css';

export default function PrivacyPage() {
  const { t } = useTranslation();

  return (
    <LegalLayout
      title={t('legal.privacy.title')}
      description={t('legal.privacy.description')}
    >
      <div className="privacyPage">
        <h1 className="privacyPage__title">{t('legal.privacy.title')}</h1>
        <p className="privacyPage__lastUpdated">
          {t('legal.privacy.lastUpdated')}: {t('legal.privacy.effectiveDate')}
        </p>

        <section className="privacyPage__section">
          <h2 className="privacyPage__heading">{t('legal.privacy.introduction.title')}</h2>
          <p className="privacyPage__text">{t('legal.privacy.introduction.content')}</p>
        </section>

        <section className="privacyPage__section">
          <h2 className="privacyPage__heading">{t('legal.privacy.informationWeCollect.title')}</h2>
          <p className="privacyPage__text">{t('legal.privacy.informationWeCollect.intro')}</p>
          <ul className="privacyPage__list">
            <li>{t('legal.privacy.informationWeCollect.accountInfo')}</li>
            <li>{t('legal.privacy.informationWeCollect.videoRecordings')}</li>
            <li>{t('legal.privacy.informationWeCollect.audioRecordings')}</li>
            <li>{t('legal.privacy.informationWeCollect.usageData')}</li>
            <li>{t('legal.privacy.informationWeCollect.deviceInfo')}</li>
          </ul>
        </section>

        <section className="privacyPage__section">
          <h2 className="privacyPage__heading">{t('legal.privacy.aiDataProcessing.title')}</h2>
          <p className="privacyPage__text">{t('legal.privacy.aiDataProcessing.intro')}</p>
          <p className="privacyPage__text">{t('legal.privacy.aiDataProcessing.gemini')}</p>
          <p className="privacyPage__text">{t('legal.privacy.aiDataProcessing.analysis')}</p>
          <p className="privacyPage__text">{t('legal.privacy.aiDataProcessing.biometric')}</p>
        </section>

        <section className="privacyPage__section">
          <h2 className="privacyPage__heading">{t('legal.privacy.thirdPartyServices.title')}</h2>
          <p className="privacyPage__text">{t('legal.privacy.thirdPartyServices.intro')}</p>
          <ul className="privacyPage__list">
            <li>
              <strong>{t('legal.privacy.thirdPartyServices.clerk.title')}</strong>: {t('legal.privacy.thirdPartyServices.clerk.description')}
            </li>
            <li>
              <strong>{t('legal.privacy.thirdPartyServices.lemonSqueezy.title')}</strong>: {t('legal.privacy.thirdPartyServices.lemonSqueezy.description')}
            </li>
            <li>
              <strong>{t('legal.privacy.thirdPartyServices.gemini.title')}</strong>: {t('legal.privacy.thirdPartyServices.gemini.description')}
            </li>
          </ul>
        </section>

        <section className="privacyPage__section">
          <h2 className="privacyPage__heading">{t('legal.privacy.dataRetention.title')}</h2>
          <p className="privacyPage__text">{t('legal.privacy.dataRetention.intro')}</p>
          <p className="privacyPage__text">{t('legal.privacy.dataRetention.recordings')}</p>
          <p className="privacyPage__text">{t('legal.privacy.dataRetention.deletion')}</p>
        </section>

        <section className="privacyPage__section">
          <h2 className="privacyPage__heading">{t('legal.privacy.dataSecurity.title')}</h2>
          <p className="privacyPage__text">{t('legal.privacy.dataSecurity.content')}</p>
        </section>

        <section className="privacyPage__section">
          <h2 className="privacyPage__heading">{t('legal.privacy.userRights.title')}</h2>
          <p className="privacyPage__text">{t('legal.privacy.userRights.intro')}</p>
          <ul className="privacyPage__list">
            <li>{t('legal.privacy.userRights.access')}</li>
            <li>{t('legal.privacy.userRights.deletion')}</li>
            <li>{t('legal.privacy.userRights.correction')}</li>
            <li>{t('legal.privacy.userRights.portability')}</li>
            <li>{t('legal.privacy.userRights.objection')}</li>
          </ul>
        </section>

        <section className="privacyPage__section">
          <h2 className="privacyPage__heading">{t('legal.privacy.cookies.title')}</h2>
          <p className="privacyPage__text">{t('legal.privacy.cookies.content')}</p>
        </section>

        <section className="privacyPage__section">
          <h2 className="privacyPage__heading">{t('legal.privacy.children.title')}</h2>
          <p className="privacyPage__text">{t('legal.privacy.children.content')}</p>
        </section>

        <section className="privacyPage__section">
          <h2 className="privacyPage__heading">{t('legal.privacy.changes.title')}</h2>
          <p className="privacyPage__text">{t('legal.privacy.changes.content')}</p>
        </section>

        <section className="privacyPage__section">
          <h2 className="privacyPage__heading">{t('legal.privacy.contact.title')}</h2>
          <p className="privacyPage__text">{t('legal.privacy.contact.content')}</p>
          <p className="privacyPage__text">
            <a href="mailto:support@bodai.io" className="privacyPage__link">support@bodai.io</a>
          </p>
        </section>
      </div>
    </LegalLayout>
  );
}

